import { LexicalSerializeChildren, serializeLexical } from './lexicalSerialize.jsx'

export type LexicalRichTextContent = { root: { children: LexicalSerializeChildren } }

type LexicalRichTextProps = { content: LexicalRichTextContent }

export const LexicalRichText = ({ content }: LexicalRichTextProps) => {
  if (!content) {
    return null
  }

  return <div>{serializeLexical(content.root.children)}</div>
}
